<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="700" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Important Update: New Purchase Hub
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      .text-md.neutral700--text You've accessed a feature from our previous system. This feature is now part of our new, comprehensive Purchase Hub, which includes:
      .my-4
        v-card.pa-3.round-xl.my-3(flat color="neutral300")
          .text-md.font-medium Smart inventory integration for quick order creation based on stock levels, usage trends and list created.
        v-card.pa-3.round-xl.my-3(flat color="neutral300")
          .text-md.font-medium Comprehensive management of Requests for Quotation, Purchase Orders, and Invoices.
        v-card.pa-3.round-xl.my-3(flat color="neutral300")
          .text-md.font-medium Real-time tracking of document, payment, and delivery statuses.
        v-card.pa-3.round-xl.my-3(flat color="neutral300")
          .text-md.font-medium Seamless inventory updates: Changes in purchasing documents automatically reflect in your inventory - eliminating double data entry!
      //- .text-md.neutral700--text The previous system will be fully replaced by the new Purchase Hub in [X days].

    v-card-actions.px-6.pb-4
      y-button(:label="$t('close')" underline size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Continue to New Purchase Hub" size="md" @click="goToPurchaseHub")

</template>

<script>

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stock: {
      default: null
    },
    product: {
      default: null
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    goToPurchaseHub () {
      this.$router.push('/admin/clinic/purchase-hub')
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
</style>